var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3.92,
    width: 20,
    height: 16.1633,
    rx: 2,
    fill: "#FAFF1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.19922 15.2832V8.67296",
    stroke: "#424242",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9496 8.67C17.1704 8.67 16.4232 8.94857 15.8722 9.44444C15.3212 9.9403 15.0117 10.6128 15.0117 11.3141V12.6361C15.0117 13.3374 15.3212 14.0099 15.8722 14.5058C16.4232 15.0017 17.1704 15.2802 17.9496 15.2802",
    stroke: "#424242",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6057 8.67267C10.2161 8.67267 9.84244 8.81196 9.56696 9.05989C9.29148 9.30782 9.13672 9.64409 9.13672 9.99472V13.9609C9.13672 14.3115 9.29148 14.6478 9.56696 14.8957C9.84244 15.1436 10.2161 15.2829 10.6057 15.2829C10.9953 15.2829 11.3689 15.1436 11.6444 14.8957C11.9198 14.6478 12.0746 14.3115 12.0746 13.9609V9.99472C12.0746 9.64409 11.9198 9.30782 11.6444 9.05989C11.3689 8.81196 10.9953 8.67267 10.6057 8.67267Z",
    stroke: "#424242",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIoc);
export default __webpack_public_path__ + "static/media/ioc.736ed075a5735ad66016a4eb75700682.svg";
export { ForwardRef as ReactComponent };